import {Dialog} from '~/src/design-system'
import {useNavigate} from 'react-router-dom'
import React, {UIEvent, useState} from 'react'
import styledSC from 'styled-components'
import {BASE_ROUTES} from '~/src/routes/constants'
import EulaContent from './EulaContent'
import {Button} from '~/src/design-system/Primitives'

const HeaderText = styledSC.h2`
  font-size: var(--fs-h2);
  font-weight: var(--fw-bold);
  padding-bottom: var(--space-8);
  margin: 0 0 var(--space-10) 0;
  width: 100%;
  flex-shrink: 0;
  border-bottom: var(--border-thin) solid var(--neutral-400);
`

const DialogContent = styledSC.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-10);
`

const DialogFooter = styledSC.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  gap: var(--space-4);
  padding-top: var(--space-10);
`

interface IProps {
  onModalClose(): void
  isModalOpen: boolean
  handleClick: (response: boolean) => void
}

export default function EulaDialog({onModalClose, isModalOpen, handleClick}: IProps): JSX.Element {
  const navigate = useNavigate()
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const handleScroll = (
    e: {
      target: {scrollHeight: number; scrollTop: number; clientHeight: number}
    } & UIEvent<HTMLDivElement>,
  ) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 25
    if (bottom) {
      setIsButtonDisabled(false)
    }
  }

  const handleSubmit = async () => {
    handleClick(true)
    // Note: Don't call onModalClose() here - let the parent handleClick decide what to do after accepting
  }

  function handleModalCancel() {
    handleClick(false)
    navigate(BASE_ROUTES.SIGNIN)
  }

  return (
    <Dialog
      fullWidth
      fullWidthPaper
      open={isModalOpen}
      onClose={handleModalCancel}
      PaperProps={{sx: {height: '100%'}}}>
      <DialogContent>
        <HeaderText>Terms & Conditions</HeaderText>

        <div
          onScroll={handleScroll}
          style={{
            width: '100%',
            border: '1px solid grey',
            overflowY: 'scroll',
            flex: '1 1 auto',
            minHeight: 0,
            borderRadius: '4px',
            padding: '25px',
          }}>
          <EulaContent />
        </div>

        <DialogFooter>
          <Button
            variant="secondary"
            type="reset"
            style={{minWidth: 120}}
            onClick={handleModalCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            style={{minWidth: 120}}
            disabled={isButtonDisabled}
            onClick={handleSubmit}>
            I Agree
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
